// extracted by mini-css-extract-plugin
export var container = "_ef-0";
export var icon = "_ef-1";
export var text = "_ef-2";